import styled from 'styled-components/native';

import { Ionicons } from '@expo/vector-icons';

export const Container = styled(Ionicons)``;
